export const authorsMetaTag = {
  mainPage: {
    title: 'İddaa Tahminleri, Maç Yorumları ve Analizleri - Bilyoner',
    desc: `İddaa tahminleri, banko ve hazır kuponlar, iddaa analizleri ve yorumları uzman 
       spor yorumcuların kalemleriyle Bilyoner'de!`
  },
  footballPage: {
    title: 'Futbol İddaa Tahminleri, Maç Yorumları, Analizleri - Bilyoner',
    desc: 'Futbol iddaa tahminleri, banko ve hazır kuponlar, Futbol maç analizleri ve yorumları uzman Futbol yorumcuların kalemleriyle Bilyoner’de!'
  },
  basketballPage: {
    title: 'Basketbol İddaa Tahminleri, Maç Yorumları, Analizleri - Bilyoner',
    desc: 'Basketbol iddaa tahminleri, banko ve hazır kuponlar, basketbol maç analizleri ve yorumları uzman basketbol yorumcuların kalemleriyle Bilyoner’de!'
  },
  volleyballPage: {
    title: 'Voleybol İddaa Tahminleri, Maç Yorumları, Analizleri - Bilyoner',
    desc: 'Voleybol iddaa tahminleri, banko ve hazır kuponlar, Voleybol maç analizleri ve yorumları uzman voleybol yorumcuların kalemleriyle Bilyoner’de!'
  },
  tennisPage: {
    title: 'Tenis İddaa Tahminleri, Maç Yorumları, Analizleri - Bilyoner',
    desc: 'Tenis iddaa tahminleri, banko ve hazır kuponlar, Tenis maç analizleri ve yorumları uzman tenis yorumcuların kalemleriyle Bilyoner’de!'
  },
  detailPage: {
    title: 'Yorumları, İddaa Kuponları - Bilyoner',
    desc: `tarafından hazırlanan iddaa kuponları, maç ve iddaa analizleri, iddaa 
    yorumları ve daha fazlası Bilyoner'de sizleri bekliyor.`
  },
  detailPageBahista: {
    title: 'Yapay Zeka ile İddaa Tahminleri - Bilyoner',
    desc: `ile İddaa tahminleri yapın, kazanın! Akıllı yapay zeka botumuzla hızlı, 
      gelişmiş algoritmalar ve istatistiklerle desteklenen etkili tahminler yapın.`
  }
};
